import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { CalendarCheck, SignIn } from "@phosphor-icons/react";

export default function CoachActivityTab() {
    const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    const load = (selectedMonth) => {
        setLoading(true);
        api.get(`/admin/coach-activity?month=${selectedMonth}`)
            .then((res) => setData(res.data))
            .catch(() => toast.error("Gagal memuat laporan kehadiran pelatih"))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        load(month);
    }, []);

    const changeMonth = (value) => {
        setMonth(value);
        load(value);
    };

    return (
        <div data-testid="coach-activity-tab">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
                <div>
                    <h2 className="font-display uppercase text-2xl text-neutral-900">Kehadiran Pelatih</h2>
                    <p className="text-sm text-racing-muted mt-2">Rekap bulanan tanggal pelatih login ke sistem dan tanggal pelatih mengisi absensi.</p>
                </div>
                <div>
                    <label className="block text-[10px] uppercase tracking-[0.2em] text-racing-muted mb-2">Bulan</label>
                    <input
                        type="month"
                        value={month}
                        onChange={(e) => changeMonth(e.target.value)}
                        data-testid="coach-activity-month-input"
                        className="bg-white border border-racing-line px-4 py-3 text-sm"
                    />
                </div>
            </div>

            {loading && <p className="text-racing-muted" data-testid="coach-activity-loading">Memuat...</p>}

            {!loading && data && data.coaches.length === 0 && (
                <p className="border border-racing-line bg-white p-6 text-sm text-racing-muted" data-testid="coach-activity-empty">Belum ada akun pelatih.</p>
            )}

            {!loading && data && data.coaches.length > 0 && (
                <div className="space-y-4" data-testid="coach-activity-list">
                    {data.coaches.map((coach, i) => (
                        <div key={coach.coach_id} className="border border-racing-line bg-white p-5 md:p-6" data-testid={`coach-activity-row-${i}`}>
                            <div className="flex flex-wrap items-baseline justify-between gap-2 mb-4">
                                <h3 className="font-display uppercase text-xl text-neutral-900" data-testid={`coach-activity-name-${i}`}>{coach.coach_name}</h3>
                                <p className="text-[10px] uppercase tracking-[0.2em] text-racing-muted">
                                    {coach.login_dates.length} hari login • {coach.session_count} sesi absen
                                </p>
                            </div>
                            <div className="grid md:grid-cols-2 gap-5">
                                <div>
                                    <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-racing-golddeep mb-2">
                                        <SignIn size={14} /> Tanggal Login
                                    </p>
                                    {coach.login_dates.length === 0 ? (
                                        <p className="text-sm text-racing-muted">Tidak ada login bulan ini.</p>
                                    ) : (
                                        <div className="flex flex-wrap gap-2">
                                            {coach.login_dates.map((date) => (
                                                <span key={date} className="px-2.5 py-1 text-xs border border-racing-line text-neutral-800" data-testid={`coach-login-date-${i}-${date}`}>
                                                    {date}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-racing-golddeep mb-2">
                                        <CalendarCheck size={14} /> Tanggal Mengabsen
                                    </p>
                                    {coach.sessions.length === 0 ? (
                                        <p className="text-sm text-racing-muted">Tidak ada sesi absensi bulan ini.</p>
                                    ) : (
                                        <div className="flex flex-wrap gap-2">
                                            {coach.sessions.map((session, si) => (
                                                <span key={`${session.date}-${si}`} className="px-2.5 py-1 text-xs border border-racing-gold/50 bg-racing-gold/10 text-neutral-800" data-testid={`coach-attend-date-${i}-${si}`}>
                                                    {session.date}{session.class_name ? ` • ${session.class_name}` : ""}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
